module.exports = __webpack_public_path__ + "img/nosupport.ddc160b.svg";